export const TERMINATED = -1
export const INACTIVE = 0
export const ACTIVE = 1
